import {createAsyncThunk, createSlice, current} from '@reduxjs/toolkit';
import {
    activateLineByIdApi,
    deleteLineByIdApi,
    fetchLineStationDepartureArrivalApi,
    getAllLines, getAllLinesPaginationAPI, getLineByFilterApi,
    getLineByIdApi,
    insertLineApi,
    searchLineStationDepartureArrivalApi,
    setLineActiveApi,
    updateLineByIdApi
} from "../../api/backendAPIs";

export const fetchAllLines = createAsyncThunk('fetchAllLines', async (payload) => {
    return await getAllLines(payload)
})

export const getAllLinesPagination = createAsyncThunk('getAllLinesPagination', async (payload) => {
    return await getAllLinesPaginationAPI(payload)
})

export const getLineByFilter = createAsyncThunk('getLineByFilter', async (payload) => {
    return await getLineByFilterApi(payload)
})

export const getLineById = createAsyncThunk('getLineById', async (payload) => {
    return await getLineByIdApi(payload)
})

export const activateLineById = createAsyncThunk('activateLineByIdApi', async (payload) => {
    return await activateLineByIdApi(payload)
})

export const deleteLineById = createAsyncThunk('deleteLineById', async (payload) => {
     await deleteLineByIdApi(payload)
    return payload
})

export const updateLineById = createAsyncThunk('updateLineByIdApi', async (payload) => {
    return await updateLineByIdApi(payload)
})

export const insertLine = createAsyncThunk('insertLine', async (payload) => {
    return await insertLineApi(payload)
})

export const setLineActive = createAsyncThunk('setLineActive', async (payload) => {
    return await setLineActiveApi(payload)
})

export const searchLineStationDepartureArrival = createAsyncThunk('searchLineStationDepartureArrival', async (payload) => {
    return await searchLineStationDepartureArrivalApi(payload)
})

export const fetchLineStationDepartureArrival = createAsyncThunk('fetchLineStationDepartureArrival', async (payload) => {
    return await fetchLineStationDepartureArrivalApi(payload)
})

const initialState = {
    allLines: [],
    linesData: {},
    allLinesBackend: [],
    insertedLine: null,
    // singleLine: null,
    loadingAllLines: false,
    lineError: null,
    searchParam: ""
}

export const linesSlice = createSlice({
    name: 'lineAutocomplete',
    initialState,
    reducers: {
        setSearchParam: (state, action) => {
            state.searchParam = action.payload
        }
    },
    extraReducers: {
        [searchLineStationDepartureArrival.pending]: (state) => {
            state.loadingAllLines = true;
        },
        [searchLineStationDepartureArrival.fulfilled]: (state, {payload}) => {
            state.loadingAllLines = false;
            state.lines = payload.data.content;
        },
        [searchLineStationDepartureArrival.rejected]: (state) => {
            state.loadingAllLines = false;
        },
        [fetchLineStationDepartureArrival.pending]: (state) => {
            state.loadingAllLines = true;
        },
        [fetchLineStationDepartureArrival.fulfilled]: (state, {payload}) => {
            state.loadingAllLines = false;
            state.allLinesBackend = payload.data.content;
        },
        [fetchLineStationDepartureArrival.rejected]: (state) => {
            state.loadingAllLines = false;
        },
        [fetchAllLines.pending]: (state) => {
            state.loadingAllLines = true;
        },
        [fetchAllLines.fulfilled]: (state, {payload}) => {
            state.loadingAllLines = false;
            state.allLines = payload.data;
        },
        [getAllLinesPagination.pending]: (state) => {
            state.loadingAllLines = true;
        },
        [getAllLinesPagination.fulfilled]: (state, {payload}) => {
            state.loadingAllLines = false;
            state.allLines = payload.data;
        },
        [getAllLinesPagination.rejected]: (state) => {
            state.loadingAllLines = false;
        },
        [getLineById.pending]: (state) => {
            state.loadingAllLines = true;
        },
        [getLineById.fulfilled]: (state, action) => {
            state.loadingAllLines = false;
            state.linesData[action.meta.arg] = action.payload;
        },
        [getLineById.rejected]: (state, {payload}) => {
            state.loadingAllLines = false;
        },
        [deleteLineById.pending]: (state) => {
            state.loadingAllLines = true;
        },
        [deleteLineById.fulfilled]: (state, action) => {
            const arr = {...current(state.allLines)}
            const index = arr.content.findIndex(i => i.id === action.payload)
            if(index !== -1){
                const res = { ...arr.content[index] };
                res.status = false
                const t = [...arr.content]
                t[index] = res
                arr.content = t
                state.allLines = arr
            }
            state.loadingAllLines = false;
        },
        [deleteLineById.rejected]: (state, action) => {
            state.loadingAllLines = false;
        },
        [updateLineById.pending]: (state) => {
            state.loadingAllLines = true;
        },
        [updateLineById.fulfilled]: (state, {payload}) => {
            const arr = {...current(state.allLines)}
            const index = arr.content.findIndex(i => i.id === payload.data.id)
            if (index !== -1) {
                const res = { ...arr.content[index] };
                const t = [...arr.content]
                t[index] = res
                arr.content = t
                state.allLines = arr
            }
            state.loadingAllLines = false;
        },
        [updateLineById.rejected]: (state, {payload}) => {
            state.loadingAllLines = false;
        },
        [activateLineById.pending]: (state) => {
            state.loadingAllLines = true;
        },
        [activateLineById.fulfilled]: (state, {payload}) => {
            const arr = {...current(state.allLines)}
            const index = arr.content.findIndex(i => i.id === payload.data.id)
            if (index !== -1) {
                const res = { ...arr.content[index] };
                res.status = true;
                const t = [...arr.content]
                t[index] = res
                arr.content = t
                state.allLines = arr
            }
            state.loadingAllLines = false;
        },
        [activateLineById.rejected]: (state, {payload}) => {
            state.loadingAllLines = false;
        },
        [insertLine.pending]: (state) => {
            state.loadingAllLines = true;
        },
        [insertLine.fulfilled]: (state, {payload}) => {
            const arr = [...current(state.allLines.content)]
            arr.push(payload.data.content)
            state.allLines = arr;
            state.loadingAllLines = false;
        },
        [insertLine.rejected]: (state, action) => {
            state.loadingAllLines = false;
            state.lineError = action.arg.msg
        }
    }
});

export const linesReducer = linesSlice.reducer

